import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { getElementsForPosition } from '../../hooks/utils';
import { LuminaSectionElement } from '../element/lumina-section-element';

import type { SectionProps } from './types';
import { getElementKey } from './utils';

const styles = cssMap({
	rowStyle: {
		width: '100%',
	},
});

const REQUIRED_ELEMENTS_COUNT = 2;

export const TwoRowSection = ({
	elements,
	key,
	isFoldable = false,
}: SectionProps): React.JSX.Element | null => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	const topElements = getElementsForPosition(elements, 'top', 0);
	const bottomElements = getElementsForPosition(elements, 'bottom', 1);

	return (
		<Stack xcss={styles.rowStyle} space="space.100">
			<Box xcss={styles.rowStyle}>
				{topElements.map((element, index) => (
					<LuminaSectionElement
						component={element}
						position="two-rows-top"
						key={getElementKey({ key, pos: element.attributes?.pos, index })}
						isFoldable={isFoldable}
					/>
				))}
			</Box>
			<Box xcss={styles.rowStyle}>
				{bottomElements.map((element, index) => (
					<LuminaSectionElement
						component={element}
						position="two-rows-bottom"
						key={getElementKey({ key, pos: element.attributes?.pos, index })}
						isFoldable={isFoldable}
					/>
				))}
			</Box>
		</Stack>
	);
};
